// Signature Library Premium Pass — six worlds + Night + Originals.
// Each sub maps to a server category (+ optional keyword filter).
const orb = (hi, mid) => `radial-gradient(circle at 50% 50%, ${hi} 0%, ${mid}cc 22%, ${mid}33 48%, rgba(13,31,58,0) 68%)`;

export const WORLDS = [
  {
    id: "calm_restore", label: "Calm & Restore", tagline: "Soft, still, moonlike. Let the system settle.",
    accent: "#a9c4a1", orb: orb("#e4ece6", "#a9c4a1"),
    subs: [
      { id: "calm", label: "Return to Calm", cat: "calm_balance" },
      { id: "body", label: "Body & Restore", cat: "wellbeing_body" },
      { id: "letting_go", label: "Letting Go", cat: "break_pattern" },
    ],
  },
  {
    id: "confidence_self", label: "Confidence & Self", tagline: "A warm inner glow. Stand fully in who you are.",
    accent: "#e0a97a", orb: orb("#ffd9a8", "#e0a97a"),
    subs: [
      { id: "self_belief", label: "Self-Belief", cat: "confidence_belief" },
      { id: "becoming", label: "Becoming", cat: "identity_transformation" },
      { id: "voice", label: "Voice & Presence", cat: "social_confidence" },
    ],
  },
  {
    id: "perform_excel", label: "Perform & Excel", tagline: "Sharper light. Play free, focus clean, rise to the moment.",
    accent: "#f2cf74", orb: orb("#fff1c2", "#f2cf74"),
    subs: [
      { id: "golf", label: "Golf", cat: "sport_movement", keyword: "golf" },
      { id: "running", label: "Running", cat: "sport_movement", keyword: "running" },
      { id: "football", label: "Football", cat: "sport_movement", keyword: "football" },
      { id: "tennis", label: "Tennis", cat: "sport_movement", keyword: "tennis" },
      { id: "padel", label: "Padel", cat: "sport_movement", keyword: "padel" },
      { id: "gym", label: "Gym", cat: "sport_movement", keyword: "gym" },
      { id: "competition", label: "Competition", cat: "sport_movement", keyword: "competition" },
      { id: "focus", label: "Focus", cat: "focus_productivity" },
      { id: "big_moments", label: "Big Moments", cat: "performance_achievement" },
    ],
  },
  {
    id: "love_connection", label: "Love & Connection", tagline: "Softer warmth. Meet others, and yourself, openly.",
    accent: "#e8b4b8", orb: orb("#f9d4d8", "#e8b4b8"),
    subs: [{ id: "love", label: "Love", cat: "love_relationships" }],
  },
  {
    id: "abundance_purpose", label: "Abundance & Purpose", tagline: "Expansive gold. A calm relationship with receiving.",
    accent: "#d7bb7a", orb: orb("#ffe7a3", "#d7bb7a"),
    subs: [{ id: "abundance", label: "Abundance", cat: "abundance_success" }],
  },
  {
    id: "rituals_life", label: "Rituals & Life", tagline: "Dawn and dusk. Small daily returns, big life doorways.",
    accent: "#d8a7b1", orb: orb("#f1c9a8", "#d8a7b1"),
    subs: [
      { id: "rituals", label: "Daily Rituals", cat: "rituals" },
      { id: "life_moments", label: "Life Moments", cat: "life_moments" },
    ],
  },
];

export const NIGHT = {
  id: "night", label: "Night", tagline: "Sleep, deep rest and overnight installations.",
  accent: "#8fa3c7", orb: orb("#dfe6f2", "#7c92b8"),
  subs: [
    { id: "sleep", label: "Sleep", cat: "sleep_recovery" },
    { id: "overnight", label: "Overnight · 6h+", cat: "overnight_installs" },
  ],
};

export const ORIGINALS = {
  id: "originals", label: "Soulumo Originals", tagline: "The philosophy behind Soulumo, in sound.",
  accent: "#d7bb7a", orb: orb("#fff3cf", "#d7bb7a"),
  subs: [{ id: "human_family", label: "The Human Family", cat: "peace_humanity" }],
};

export const ALL_SPACES = [...WORLDS, NIGHT, ORIGINALS];
export const spaceById = (id) => ALL_SPACES.find((w) => w.id === id);

const hay = (i) => [i.id, i.label, i.theme, i.custom_concern, i.blurb].filter(Boolean).join(" ").toLowerCase();
const inSub = (sub, i) => i.category === sub.cat && (!sub.keyword || hay(i).includes(sub.keyword));

// Each item lands in the FIRST sub that matches, so nothing repeats.
export function groupBySub(space, items) {
  const seen = new Set();
  return space.subs
    .map((sub) => {
      const rows = items.filter((i) => !seen.has(i.id) && inSub(sub, i));
      rows.forEach((r) => seen.add(r.id));
      return { sub, rows };
    })
    .filter((g) => g.rows.length);
}

export const subLabelFor = (i) => {
  for (const s of ALL_SPACES) for (const sub of s.subs) if (inSub(sub, i)) return sub.label;
  return "";
};

const RENAMES = {
  "My Long Game": "The Long Game",
  "My Competition": "Competition",
  "Pre Tee Primer": "Pre-Tee",
  "Poor Shot Reset": "Reset",
  "Flow State Reset": "Flow State",
  "My Putting": "Putting",
  "My Short Game": "Short Game",
  "Sleep — Day": "Daytime Rest",
  "Sleep — Night": "The Long Night",
};

// "Golf · My Long Game" → "The Long Game" — context lives in the overline.
export function displayName(i) {
  const label = i.label || "";
  if (RENAMES[label]) return RENAMES[label];
  const stripped = label.replace(/^(Golf|Overnight)\s*[·—-]\s*/i, "");
  return RENAMES[stripped] || stripped;
}
